import styled from 'styled-components';
import { primary, secondary, lightGray, white, middleGray, darkGray, success, error } from 'styles/colorProvider';

export const Container = styled.div`
  background-color: ${white};
  width: 100%;
  margin-bottom: 100px;
  display: flex;
  align-items: top;
  justify-content: center;
`;

export const ContentArea = styled.div`
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: left;

  @media (max-width: 1000px) {
    align-items: center;
    width: 95%;
  }
`;

export const Title = styled.h1`
  font-size: 28px;
  color: ${primary};

  @media (max-width: 1000px) {
    text-align: center;
    margin-top: 10%;
  }
`;

export const PolicyInformationArea = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 20px;
  gap: 20px;

  @media (max-width: 1000px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const ItemPolicy = styled.div`
  border: 1px solid ${lightGray};
  border-radius: 20px;
  width: ${(props) => (props.fullWidth ? '100%' : '48%')};
  padding: 2.2% 3%;
  background: ${white};

  @media (max-width: 1000px) {
    width: 100%;
    padding: 30px;
  }
`;

export const Subtitle = styled.h2`
  color: ${primary};
  font-size: 18px;
  font-weight: bold;
  margin: 0;
  margin-bottom: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Text = styled.p`
  font-size: 14px;
  color: ${darkGray};
  margin: 0;
  margin-top: 2%;

  span {
    color: ${middleGray};
    font-weight: 500;
  }
`;

export const LoadingArea = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding-top: 30px;
`;

export const CoveragesArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
`;

export const ProductItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 15px;
  background: #fcfcfc;
  border: 1px solid ${(props) => (props.selected ? success : '#eee')};
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${secondary};
    background: #f8f9fa;
  }

  .info {
    display: flex;
    align-items: center;
    gap: 10px;

    svg {
      color: ${(props) => (props.selected ? success : middleGray)};
    }

    span {
      font-size: 14px;
      font-weight: 500;
      color: ${primary};
    }
  }

  .value {
    font-size: 14px;
    font-weight: 600;
    color: ${darkGray};
  }
`;

export const ValueComparison = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  margin: 2rem 0;
  padding: 20px;
  background: #fdfdfd;
  border-radius: 16px;
  border: 1px dashed #ddd;
`;

export const ValueCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 160px;

  label {
    font-size: 11px;
    color: ${middleGray};
    text-transform: uppercase;
    font-weight: 700;
    margin-bottom: 5px;
  }

  span {
    font-size: 22px;
    font-weight: 800;
    color: ${(props) => (props.variant === 'success' ? success : props.variant === 'error' ? error : primary)};
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #eee;
`;
